module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-filter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md title"
  }, [_vm._v(" " + _vm._s(_vm.title[_vm.$route.name]) + "\n      "), _c('em', [_vm._v(_vm._s(_vm.totalItemsCount) + " Results  ( Filtered to " + _vm._s(_vm.filteredItemsCount) + " results )")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md show"
  }, [_c('span', [_vm._v("Show me:")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'all'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'all'
        })
      }
    }
  }, [_vm._v("All Results")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'videos'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'videos'
        })
      }
    }
  }, [_vm._v("Videos")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'figures'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'figures'
        })
      }
    }
  }, [_vm._v("Figures")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.queryParams.show == 'tags'
    },
    on: {
      "click": function($event) {
        _vm.onChangeQueryParams({
          show: 'tags'
        })
      }
    }
  }, [_vm._v("Tags")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-params row m-0 justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-auto"
  }, [_c('span', [_vm._v("Filter By:")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.paperType,
      "options": _vm.paperTypes
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          paperType: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.author,
      "options": _vm.authors
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          author: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.keyword,
      "options": _vm.keywords
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          keyword: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.vol,
      "options": _vm.volumes
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          vol: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.issue,
      "options": _vm.issues
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          issue: $event
        })
      }
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "custom-select",
    attrs: {
      "value": _vm.queryParams.date,
      "type": "date",
      "placeholder": "Date"
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          date: $event
        })
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-auto"
  }, [_c('span', [_vm._v("Sort By:")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "value": _vm.queryParams.sortBy,
      "options": _vm.sortBy
    },
    on: {
      "input": function($event) {
        _vm.onChangeQueryParams({
          sortBy: $event
        })
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 justify-content-between filter-labels"
  }, [_c('div', {
    staticClass: "col-md p-0"
  }, _vm._l((_vm.queryParams), function(value, key) {
    return (value && key !== 'sortBy' && key !== 'show') ? _c('filter-label', {
      key: value,
      attrs: {
        "param-name": key
      },
      on: {
        "remove": function($event) {
          _vm.removeFilter($event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(value))]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-auto"
  }, [_c('b-button', {
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n        Clear Filters\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c309c59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-results/SearchFilterComponent.vue
// module id = 1385
// module chunks = 1